import { IApplicationState } from '../../types/redux';

export const selectSelectedEntitiesCount = (state: IApplicationState) => {
  return Object.keys(state.selected).length;
};
